import React, { useCallback, useMemo } from 'react'

import { PhotoThumbnail } from '@components/common/PhotoThumbnail'
import { StatusTag } from '@components/common/StatusTag'
import { Colors, Dropdown, ToolbarButton } from '@fourthwall/components'
import { DotsHorizontalIcon } from '@fourthwall/icons'

import type { Offers } from '../../types'
import * as S from './styled'

type SelectedProductsListItemProps = {
  product: Offers[0]
  disabled?: boolean
  onRemove: () => void
  onPositionChange: () => void
}

export const SelectedProductsListItem = ({
  product,
  disabled,
  onRemove,
  onPositionChange,
}: SelectedProductsListItemProps) => {
  const dropdownAction = useCallback((event: React.MouseEvent, action: () => void) => {
    event.preventDefault()
    action()
  }, [])

  const dropdownContent = useMemo(
    () => (
      <>
        <Dropdown.Item
          label="Remove from collection"
          onClick={(e: React.MouseEvent) => dropdownAction(e, onRemove)}
        />
        {!disabled && (
          <Dropdown.Item
            label="Change position"
            onClick={(e: React.MouseEvent) => dropdownAction(e, onPositionChange)}
          />
        )}
      </>
    ),
    [disabled, dropdownAction, onRemove, onPositionChange],
  )

  return (
    <S.Container>
      <S.LeftSide>
        <PhotoThumbnail url={product.primaryImage?.thumbnail.url} size="medium" />
        <S.Details>
          <div>{product.name}</div>
          <StatusTag status={product.state.status} isSoldOut={!product.state.available} />
        </S.Details>
      </S.LeftSide>

      <S.RightSide>
        <Dropdown content={dropdownContent}>
          <ToolbarButton icon={DotsHorizontalIcon} color={Colors.GS600} />
        </Dropdown>
      </S.RightSide>
    </S.Container>
  )
}
